/**
 * ! This file was generated by swagger-typescript-api. Do not change the file directly.
 */

import { PRODUCT_JOURNEY_GIRAR } from '../../../shared/utils/src/apis-paths'

import {
  type CommonCustomErrorResponse,
  type ProblemDetails,
  type RevenuesDeleteRevenueDocumentationRequest,
  type RevenuesUpdateCurrentAmountRevenueRequest,
  type WebV1RevenueAbandonDocumentationDeleteData,
  type WebV1RevenueConfirmDocumentationPartialUpdateData,
  type WebV1RevenueFileDocumentationDeleteData,
  type WebV1RevenueListData,
  type WebV1RevenueListParams,
  type WebV1RevenuePartialUpdateData,
  type WebV1RevenueStartDocumentationCreateData,
  type WebV1RevenueUploadDocumentationCreateData
} from './data-contracts'
import { type RequestParams, HttpClient } from './http-client'

class Revenue extends HttpClient {
  private static httpInstance = new HttpClient(`${PRODUCT_JOURNEY_GIRAR}/api/web/v1/revenue`)

  /**
   * No description
   *
   * @tags web
   * @name WebV1RevenueList
   * @request GET:/api/web/v1/revenue
   * @secure
   * @response `200` `WebV1RevenueListData` OK
   * @response `400` `CommonCustomErrorResponse` Bad Request
   * @response `403` `ProblemDetails` Forbidden
   */
  static async webV1RevenueList(query: WebV1RevenueListParams, params: RequestParams = {}) {
    return this.httpInstance.get<WebV1RevenueListData, CommonCustomErrorResponse | ProblemDetails>({
      url: ``,
      query: query,
      ...params
    })
  }

  /**
   * No description
   *
   * @tags web
   * @name WebV1RevenuePartialUpdate
   * @request PATCH:/api/web/v1/revenue
   * @secure
   * @response `200` `WebV1RevenuePartialUpdateData` OK
   * @response `400` `CommonCustomErrorResponse` Bad Request
   * @response `403` `ProblemDetails` Forbidden
   */
  static async webV1RevenuePartialUpdate(data: RevenuesUpdateCurrentAmountRevenueRequest, params: RequestParams = {}) {
    return this.httpInstance.patch<WebV1RevenuePartialUpdateData, CommonCustomErrorResponse | ProblemDetails>({
      url: ``,
      body: data,
      ...params
    })
  }

  /**
   * No description
   *
   * @tags web
   * @name WebV1RevenueAbandonDocumentationDelete
   * @request DELETE:/api/web/v1/revenue/abandon-documentation
   * @secure
   * @response `200` `WebV1RevenueAbandonDocumentationDeleteData` OK
   * @response `400` `CommonCustomErrorResponse` Bad Request
   * @response `403` `ProblemDetails` Forbidden
   */
  static async webV1RevenueAbandonDocumentationDelete(params: RequestParams = {}) {
    return this.httpInstance.delete<
      WebV1RevenueAbandonDocumentationDeleteData,
      CommonCustomErrorResponse | ProblemDetails
    >({
      url: `/abandon-documentation`,
      ...params
    })
  }

  /**
   * No description
   *
   * @tags web
   * @name WebV1RevenueConfirmDocumentationPartialUpdate
   * @request PATCH:/api/web/v1/revenue/confirm-documentation
   * @secure
   * @response `200` `WebV1RevenueConfirmDocumentationPartialUpdateData` OK
   * @response `400` `CommonCustomErrorResponse` Bad Request
   * @response `403` `ProblemDetails` Forbidden
   */
  static async webV1RevenueConfirmDocumentationPartialUpdate(params: RequestParams = {}) {
    return this.httpInstance.patch<
      WebV1RevenueConfirmDocumentationPartialUpdateData,
      CommonCustomErrorResponse | ProblemDetails
    >({
      url: `/confirm-documentation`,
      ...params
    })
  }

  /**
   * No description
   *
   * @tags web
   * @name WebV1RevenueFileDocumentationDelete
   * @request DELETE:/api/web/v1/revenue/file-documentation
   * @secure
   * @response `200` `WebV1RevenueFileDocumentationDeleteData` OK
   * @response `400` `CommonCustomErrorResponse` Bad Request
   * @response `403` `ProblemDetails` Forbidden
   */
  static async webV1RevenueFileDocumentationDelete(
    data: RevenuesDeleteRevenueDocumentationRequest,
    params: RequestParams = {}
  ) {
    return this.httpInstance.delete<
      WebV1RevenueFileDocumentationDeleteData,
      CommonCustomErrorResponse | ProblemDetails
    >({
      url: `/file-documentation`,
      body: data,
      ...params
    })
  }

  /**
   * No description
   *
   * @tags web
   * @name WebV1RevenueStartDocumentationCreate
   * @request POST:/api/web/v1/revenue/start-documentation
   * @secure
   * @response `200` `WebV1RevenueStartDocumentationCreateData` OK
   * @response `204` `void` No Content
   * @response `400` `CommonCustomErrorResponse` Bad Request
   * @response `403` `ProblemDetails` Forbidden
   */
  static async webV1RevenueStartDocumentationCreate(params: RequestParams = {}) {
    return this.httpInstance.post<WebV1RevenueStartDocumentationCreateData, CommonCustomErrorResponse | ProblemDetails>(
      {
        url: `/start-documentation`,
        ...params
      }
    )
  }

  /**
   * No description
   *
   * @tags web
   * @name WebV1RevenueUploadDocumentationCreate
   * @request POST:/api/web/v1/revenue/upload-documentation
   * @secure
   * @response `200` `WebV1RevenueUploadDocumentationCreateData` OK
   * @response `400` `CommonCustomErrorResponse` Bad Request
   * @response `403` `ProblemDetails` Forbidden
   */
  static async webV1RevenueUploadDocumentationCreate(
    data: {
      /** @format binary */
      File: File
      /** @format binary */
      FileName?: File
    },
    params: RequestParams = {}
  ) {
    return this.httpInstance.post<
      WebV1RevenueUploadDocumentationCreateData,
      CommonCustomErrorResponse | ProblemDetails
    >({
      url: `/upload-documentation`,
      body: data,
      ...params
    })
  }
}

export default Revenue
